<template>
  <div class="w-full">
    <Head title="Panel administracyjny" />
    <div class="mb-8">
      <h1 class="mb-2 text-3xl font-bold text-gray-900">Panel administracyjny</h1>
      <p class="text-gray-600">
        Zarządzaj swoimi stronami statycznymi z tego miejsca.
      </p>
    </div>

    <!-- Stats Cards -->
    <div class="mb-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      <div
        class="overflow-hidden rounded-lg bg-white shadow-sm transition-shadow hover:shadow-md"
      >
        <div class="p-6">
          <div class="flex items-center">
            <div class="shrink-0 rounded-md bg-code-medical-center-admin p-3">
              <icon name="office" class="h-6 w-6 fill-white" />
            </div>
            <div class="ml-5 w-0 flex-1">
              <dl>
                <dt class="text-sm font-medium text-gray-500 truncate">
                  Centrum Medyczne CODE
                </dt>
                <dd class="flex items-baseline">
                  <div class="text-2xl font-semibold text-gray-900">
                    Panel administracyjny
                  </div>
                </dd>
              </dl>
            </div>
          </div>
          <div class="mt-4">
            <Link
              :href="$routes.admin_code_medical_center()"
              class="text-sm font-medium text-code-medical-center-admin hover:opacity-80"
            >
              Zarządzaj stroną Centrum Medycznego CODE →
            </Link>
          </div>
        </div>
      </div>

      <div
        class="overflow-hidden rounded-lg bg-white shadow-sm transition-shadow hover:shadow-md"
      >
        <div class="p-6">
          <div class="flex items-center">
            <div class="shrink-0 rounded-md p-3 bg-infertility-clinic-admin">
              <icon name="office" class="h-6 w-6 fill-white" />
            </div>
            <div class="ml-5 w-0 flex-1">
              <dl>
                <dt class="text-sm font-medium text-gray-500 truncate">
                  Klinika Przyczynowego Leczenia Niepłodności
                </dt>
                <dd class="flex items-baseline">
                  <div class="text-2xl font-semibold text-gray-900">
                    Panel administracyjny
                  </div>
                </dd>
              </dl>
            </div>
          </div>
          <div class="mt-4">
            <Link
              :href="$routes.admin_infertility_treatment_clinic()"
              class="text-sm font-medium hover:opacity-80 text-infertility-clinic-admin"
            >
              Zarządzaj stroną Kliniki Przyczynowego Leczenia Niepłodności →
            </Link>
          </div>
        </div>
      </div>

      <div
        class="overflow-hidden rounded-lg bg-white shadow-sm transition-shadow hover:shadow-md"
      >
        <div class="p-6">
          <div class="flex items-center">
            <div class="shrink-0 rounded-md p-3 bg-family-clinic-admin">
              <icon name="office" class="h-6 w-6 fill-white" />
            </div>
            <div class="ml-5 w-0 flex-1">
              <dl>
                <dt class="text-sm font-medium text-gray-500 truncate">
                  Klinika Zdrowia Rodziny
                </dt>
                <dd class="flex items-baseline">
                  <div class="text-2xl font-semibold text-gray-900">
                    Panel administracyjny
                  </div>
                </dd>
              </dl>
            </div>
          </div>
          <div class="mt-4">
            <Link
              :href="$routes.admin_family_clinic()"
              class="text-sm font-medium hover:opacity-80 text-family-clinic-admin"
            >
              Zarządzaj stroną Kliniki Zdrowia Rodziny →
            </Link>
          </div>
        </div>
      </div>

      <div
        class="overflow-hidden rounded-lg bg-white shadow-sm transition-shadow hover:shadow-md"
      >
        <div class="p-6">
          <div class="flex items-center">
            <div class="shrink-0 rounded-md p-3 bg-institute-admin">
              <icon name="office" class="h-6 w-6 fill-white" />
            </div>
            <div class="ml-5 w-0 flex-1">
              <dl>
                <dt class="text-sm font-medium text-gray-500 truncate">
                  Instytut
                </dt>
                <dd class="flex items-baseline">
                  <div class="text-2xl font-semibold text-gray-900">
                    Panel administracyjny
                  </div>
                </dd>
              </dl>
            </div>
          </div>
          <div class="mt-4">
            <Link
              :href="$routes.admin_institute()"
              class="text-sm font-medium hover:opacity-80 text-institute-admin"
            >
              Zarządzaj stroną Instytutu →
            </Link>
          </div>
        </div>
      </div>
    </div>

    <!-- Homepage Link Section -->
    <div class="mb-8">
      <div class="overflow-hidden rounded-lg bg-white shadow-sm transition-shadow hover:shadow-md">
        <div class="p-6">
          <h2 class="mb-2 text-xl font-semibold text-gray-900">Strona główna</h2>
          <p class="mb-4 text-gray-600">
            Zarządzaj swoimi stronami statycznymi z tego miejsca.
          </p>
          <Link
            href="/"
            class="text-sm font-medium hover:opacity-80 text-blue-600"
          >
            Zobacz stronę główną →
          </Link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import AdminLayout from '@/Layouts/Admin.vue';
import Icon from '@/Shared/Icon.vue';

export default {
  components: {
    Head,
    Link,
    Icon,
  },
  layout: AdminLayout,
};
</script>
